import React, { useEffect } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import Progress from 'components/Misc/Progress';
// import Pagination from 'components/Misc/Pagination';

import Search from 'containers/Teacher/Subjects/Profile/Students/Search';
import Student from 'containers/Teacher/Subjects/Profile/Students/Student';

import { useSubjectStudentStore } from 'store/subject/useSubjectStudentStore';

const Students = ({ tab, setTab }) => {
	// Store subject's id
	const { id } = useParams();

	// Update selected tab
	useSingleEffect(() => setTab(tab));

	// Use subject's store
	const [parameters, students, onInit, onReset] = useSubjectStudentStore(state => [
		state.parameters,
		state.students,
		state.onInit,
		state.onReset
	]);

	// Store requested materials
	const [[, progress], collect] = useCollect(`subjects/${id}`, parameters, onInit);

	// Collect materials on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	useEffect(() => {
		return () => {
			onReset();
		};
	}, []);

	return (
		<>
			{/* Search container */}
			<Search />

			{/* Show loading progress */}
			<Progress progress={progress} />

			{/* Collection's results */}
			<div className="mt-4 bg-white dark:bg-neutral-800 rounded-lg divide-y divide-neutral-100 dark:divide-neutral-700">
				{students?.map(student =>
					<Student key={student.id} student={student} />
				)}
			</div>

			{/* Collection's pagination */}
			{/* <Pagination
				progress={progress}
				total={results?.total}
				active={search.page}
				onChange={onSearch}
				className="mt-4 mx-auto"
			/> */}
		</>
	);
};

export default Students;
